import React from 'react';

const DownArrow = () => (
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.175 0.0283203L5 3.845L8.825 0.0283203L10 1.20332L5 6.20334L0 1.20332L1.175 0.0283203Z"
      fill="#505050"
      fillOpacity="0.3"
    />
  </svg>
);

export default DownArrow;
